// --- LAYOUT, COMPONENTS, PARTS --- //
$(function () {
    fn_layout_main();

    fn_layout_header_appending();

    fn_layout__header_layout();

    fn_layout__header();

    fn_part_slider();

    fn_comp_map();

    fn_comp_contact();

    fn_part_products();

    fn_part_aside_sort();

    fn_part_gallery_slider();

    fn_part_detail_area();

    fn_part_form();

    fn_part_number();

    fn_part_wsw();
});

//--- MISC --- //
$(function () {
    nl_fn_cookie();

    nl_fn_footer();

    // nl_fn_check_size();

    nl_fn_anchor_link();

    nl_fn_dialog();

});